<script setup lang="ts">
import get from 'lodash/get'
import { useNuxtApp } from '#imports'

defineProps<{
  items: Array<any>
  visibleColumns: Array<any>
}>()

const emit = defineEmits(['restoreRecord'])

const { $voix } = useNuxtApp()

function getFieldValue(item: object, field: string, format: (string: any, record: any) => string | undefined) {
  if (field === 'language_code') {
    const language = $voix.options.languages.find((language: any) => language.code === get(item, field))
    if (language)
      return language.icon
  }

  if (format)
    return format(get(item, field), item)
  return get(item, field)
}

function restoreRecord(item: any) {
  emit('restoreRecord', item)
}
</script>

<template>
  <tbody>
    <tr
      v-for="item in items" :key="item.id"
      class="group cursor-pointer hover:voix-admin-bg-lightest duration-200 border-b voix-admin-border-light"
    >
      <td
        v-for="column in visibleColumns" :key="column.field"
        class="py-3 px-4 text-xs text-gray-600 group-hover:text-gray-900 font-medium"
      >
        <div v-html="getFieldValue(item, column.field, column.format)" />
      </td>

      <td>
        <button class="uppercase font-bold text-2xs rounded-full border voix-admin-border-light hover:voix-admin-bg-dark hover:voix-admin-text-lightest px-3 py-1" @click="restoreRecord(item)">
          Restore
        </button>
      </td>
    </tr>
  </tbody>
</template>
